import PropTypes from "prop-types";
import styles from "./index.css";

const LoadedItemsWrapper = ({ children }) => (
  <div className={styles.loadedItemsWrapper}>{children}</div>
);

LoadedItemsWrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ])
};

export default LoadedItemsWrapper;
